import axios from "axios";
import { Base_URL } from "../url";

export const saveCountryDetails = async (countryData, username) => {
  try {
    const response = await axios.post(
      `${Base_URL}/CountryMaster/CountryMaster?UserName=${username}`,
      countryData
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving country details!";
  }
};